import React from 'react';
import { FormattedMessage } from 'react-intl';

// constants
import { USER_FILTER_FIELD_NAMES } from '../../../../../../constraints';

// Components
import { ControlledTextField } from '../../../../../../components/ControlledTextField';
import { FieldLabel } from '../../../../../../components/Form';

const TextEmailField = ({ name = USER_FILTER_FIELD_NAMES.EMAIL }) => {
  return (
    <>
      <FieldLabel>
        <FormattedMessage id="Email" defaultMessage="Email" />
      </FieldLabel>
      <ControlledTextField name={name} />
    </>
  );
};

export default TextEmailField;
